import React from "react";
import { BeatLoader } from "react-spinners";

export const BotLoader = () => {
  return <BeatLoader color="#6da9b3" size={15} margin={2} />;
};
